define('appkit/app',['require','exports','module','backbone','underscore','marionette','backbone.radio','bluebird','./controller.service','./resource.service','./module.loader','./interceptor.manager'],function(require, exports, module){
  var Backbone           = require('backbone');
  var _                  = require('underscore');
  var Mn                 = require('marionette');
  var Radio              = require('backbone.radio');
  var Promise            = require('bluebird');
  var ControllerService  = require('./controller.service');
  var ResourceService    = require('./resource.service');
  var ModuleLoader       = require('./module.loader');
  var InterceptorManager = require('./interceptor.manager');

  var App = Mn.Object.extend({

    initialize: function() {
      this.readyInterceptorManager = new InterceptorManager();
      _.extend(this, this.options);
      // register a global route handler
      // Backbone.history.on('route', this.onGlobalRoute, this);
      // initialize the app channels
      this._initChannel();
      
      // unless disable ajax is specified
      // then enable ajax
      if (this.disbableDatakit !== true) {
        Radio.channel('datakit').trigger('enable');
      }

      try {
        ModuleLoader.loadModules({
          'appkit/controller.service': ControllerService,
          'appkit/resource.service': ResourceService
        });

        ModuleLoader.loadModules(this.loadModules);
      } catch (e) {
        Promise.reject(e);
        throw e;
      }

      Radio.channel('global').reply('app', this);

      this.channel.trigger('before:configure', this);
      this.channel.trigger('configure', this);
    },

    hasStartHandler: function() {
      return _.has(this.channel._events, 'start') && !_.isEmpty(this.channel._events.start);
    },

    _initChannel: function() {
      this.channelName = _.result(this, 'channelName') || 'app';
      this.channel     = _.result(this, 'channel') || Radio.channel(this.channelName);
    },

    registerReadyInterceptor: function(interceptor, context) {
      this.readyInterceptorManager.register(interceptor, context);
      return this;
    },

    ready: function() {
      if (this.isReady) { return this; }
      this.isReady = true;
      this.channel.trigger('before:ready', this);
      this.readyInterceptorManager.start()
          .bind(this)
          .catch(function(e) {
            this.channel.trigger('ready:failed', this, e);
            throw e;
          })
          .tap(function() {
            this.channel.trigger('ready', this);
          });
      return this;
    },

    start: function(options) {
      if (this.isStarted) { return this; }

      this.isStarted = true;
      var hasStartHandler = this.hasStartHandler();

      this.channel.trigger('before:start', options);
      this.channel.trigger('start', options);

      if (!hasStartHandler) {
        // if nothing is listening to start, then
        // go ahead an trigger ready
        this.ready();
      }
      return this;
    }

  });

  module.exports = App;
});
